import React from 'react';
import PropTypes from 'prop-types';
import { Common } from 'ws-scripts/modules/common';

const validDecimal = /^\d+(\.\d+)?$/;
const validateInput = v => {
	return validDecimal.test(v);
};

class PercentInput extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false, value: this.props.value };
	}

	componentDidUpdate(prevProps) {
		if (this.props.value !== prevProps.value) {
			// eslint-disable-next-line react/no-did-update-set-state
			this.setState({ value: this.props.value });
		}
	}

	render() {
		let component = null;
		const { updateValue, placeholder, passedProps } = this.props;
		let extraClassName = '';
		let errorFeedback = '';

		if (this.state.hasError) {
			extraClassName = 'has-error';
			errorFeedback = (
				<div className="pc-error-msg help-block">
					Numeric Values Only
				</div>
			);
		}
		component = (
			<Common
				render={({ labels }) => {
					return (
						<div className={`form-group ${extraClassName}`}>
							<label htmlFor="pc-APR" className="control-label">
								{labels.get('APR')}
								<input
									type="text"
									id={passedProps.inputId}
									className={passedProps.inputClassName}
									placeholder={placeholder}
									value={this.state.value}
									onChange={e => {
										const val = e.target.value;
										if (validateInput(val)) {
											let newAPR;
											if (typeof val === 'string') {
												newAPR = parseFloat(val);
											} else {
												newAPR = val;
											}
											updateValue(newAPR);
											this.setState({
												value: e.target.value,
												hasError: false
											});
										} else {
											this.setState({
												value: e.target.value,
												hasError: true
											});
										}
									}}
								/>
								{errorFeedback}
							</label>
						</div>
					);
				}}
			/>
		);
		return component;
	}
}

PercentInput.propTypes = {
	value: PropTypes.number.isRequired,
	updateValue: PropTypes.func.isRequired,
	placeholder: PropTypes.string,
	passedProps: PropTypes.shape({
		inputId: PropTypes.string,
		inputClassName: PropTypes.string
	})
};

PercentInput.defaultProps = {
	placeholder: '',
	passedProps: {}
};

export default PercentInput;



// WEBPACK FOOTER //
// ./src/components/inputs/PercentInput.jsx